import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const RealtimeClient = () => import(/* webpackChunkName: "4-feat-realtime" */ './RealtimeClient');

export default lazyLoadOnRender({ loader: RealtimeClient });
